import { TeenagerProcessHearingType } from 'types/teenager-process-hearing.type'
import React, { Fragment, useState } from 'react'
import { Funcionalidades } from 'utils/helpers/funcionalidades'
import { IconButton, Tooltip } from '@mui/material'
import EditCalendarIcon from '@mui/icons-material/EditCalendar'
import ModalSaveHistoryPendingProcessHearing from 'pages/ModalSaveHistoryPendingProcessHearing'

type EditarStatusModalProps = {
  onHasPermission: (permission: string) => boolean
  onChangeAdolescenteStatus: (
    index?: number | null,
    props?: TeenagerProcessHearingType,
  ) => Promise<void>
  adolescente: TeenagerProcessHearingType
  index: number
  disabled?: boolean
}

export const EditarStatusModal = ({
  onHasPermission,
  onChangeAdolescenteStatus,
  adolescente,
  index,
  disabled,
}: EditarStatusModalProps) => {
  const [open, setOpen] = useState<boolean>(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleUpdate = async (index?: number | null, props?: TeenagerProcessHearingType) => {
    await onChangeAdolescenteStatus(index, props).finally(() => handleClose())
  }

  return (
    <Fragment>
      {onHasPermission(Funcionalidades.integraPolicial.adolescente.informarStatus) && (
        <Tooltip title='Informar status da Oitiva.' placement={'top'}>
          <IconButton size='medium' disabled={disabled} onClick={handleOpen}>
            <EditCalendarIcon fontSize='inherit' />
          </IconButton>
        </Tooltip>
      )}
      <ModalSaveHistoryPendingProcessHearing
        open={open}
        onClose={handleUpdate}
        adolescenteToChange={adolescente}
        indexAdolescente={index}
      />
    </Fragment>
  )
}
